import React, { useContext } from "react";
import { useParams } from "react-router-dom";
import { AuthContext } from "../../../AuthContextWrapper";
import { LARAVEL_APP_HOST } from "../../../constants";
import {
  Box,
  Button,
  Typography,
  List,
  ListItemIcon,
  ListItem,
  ListItemText,
} from "@mui/material";

import { FlowScreenWrapper } from "../shared/FlowScreenWrapper";

import stressedPicture from "../../assets/StressedPicture.png";

import { ReactComponent as GreenCheckball } from "../../assets/green-checkball.svg";

export enum Outcomes {
  upgrade = "Upgrade and see other benefits",
  cancel = "No thanks, I don't need a financial advisor",
}

const upsellBullets = [
  "Required probate forms for your state",
  "Detailed estate reports you can share",
  "Automatically sync financial accounts",
];

export const PaymentRequiredScreen = (): JSX.Element => {
  const { flow } = useContext(AuthContext);
  const { screenName } = useParams();
  const currentScreen = flow?.getCurrentFlowScreen(screenName);

  const handleComplete = async (outcome: string): Promise<boolean> => {
    if (!currentScreen) throw Error("couldn't determine currentScreen");

    if (outcome == Outcomes.cancel) {
      window.location.href = `${LARAVEL_APP_HOST}/home`;
    } else if (outcome == Outcomes.upgrade) {
      // Store something in LocalStore and redirect to Vue payment page.
      window.location.href = `${LARAVEL_APP_HOST}/payment-plan`;
    } else {
      throw "Unsupported Outcome";
    }
    return true;
  };

  return currentScreen ? (
    <FlowScreenWrapper centerContent={true}>
      <>
        <Box
          sx={{
            my: 2,
            textAlign: "center",
          }}
        >
          <img
            width="150"
            height="150"
            src={stressedPicture}
            alt="Elderly lady with her finger on her forehead, contemplating."
            title="You need a paid plan"
          />
        </Box>
        <Box
          sx={{
            my: 2,
            textAlign: "center",
          }}
        >
          <Typography component="h2" variant="h3">
            Hmmm... Before we can connect you with a financial advisor, you need
            a paid Atticus plan.
          </Typography>
          <Typography
            variant="body1"
            sx={{
              my: 2,
              mx: "auto",
              width: "80%",
              maxWidth: 480,
            }}
          >
            Here are a few of the additional benefits you’ll get when you
            upgrade:
          </Typography>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
              textAlign: "left",
            }}
          >
            <List
              sx={{
                margin: "auto",
              }}
            >
              {upsellBullets.map((bullet, index) => (
                <ListItem key={index}>
                  <ListItemIcon sx={{ minWidth: "0", marginRight: "1rem" }}>
                    <GreenCheckball />
                  </ListItemIcon>
                  <ListItemText primary={bullet} />
                </ListItem>
              ))}
            </List>
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            my: "1.5rem",
          }}
        >
          <Button
            variant="contained"
            onClick={() => {
              handleComplete(Outcomes.upgrade);
            }}
            sx={{
              mb: "1rem",
            }}
          >
            {Outcomes.upgrade}
          </Button>
          <Button
            variant="text"
            onClick={() => {
              handleComplete(Outcomes.cancel);
            }}
            sx={{
              mb: "1rem",
            }}
          >
            {Outcomes.cancel}
          </Button>
        </Box>
      </>
    </FlowScreenWrapper>
  ) : (
    <></>
  );
};
